import { render, staticRenderFns } from "./LessIcon.vue?vue&type=template&id=82de2142"
import script from "./LessIcon.vue?vue&type=script&lang=js"
export * from "./LessIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports